import { EProductType } from 'v2/interfaces/product';
import { ruleRunner } from 'validations/ruleRunner';
import { required, minimun, maximum, ruleIf, ruleIfEquals, ruleIfValue } from 'validations/rules';

export const allUsersSubscriptionValidation = [
  ruleRunner(
    'recurring_value',
    'preço recorrente',
    required,
    ruleIfValue('type', EProductType.DIGITAL, minimun('1.00')),
    ruleIfValue('type', EProductType.PHYSICAL, minimun('1.00'))
  ),
  ruleRunner('recurring_frequency', 'frequência', required, minimun(1), maximum(99)),
  ruleRunner('overdue_limit', 'limite de atraso', required, minimun(1), maximum(99)),
  ruleRunner(
    'limit_charges',
    'limite de cobranças',
    ruleIfEquals('undetermined_charges', false, required),
    ruleIfEquals('undetermined_charges', false, minimun(2)),
    ruleIfEquals('undetermined_charges', false, maximum(99))
  ),
  ruleRunner('membership_price', 'preço da adesão', ruleIf('membership_fee', required), ruleIf('membership_fee', minimun('1,00'))),
  ruleRunner('trial_days', 'dias de trial', ruleIf('trial', required), ruleIf('trial', minimun(1))),
  ruleRunner(
    'recurring_days_start_charging',
    'dias para início da cobrança',
    ruleIf('recurring_days_start_charging', required),
    ruleIf('recurring_days_start_charging', minimun(1)),
    ruleIf('recurring_days_start_charging', maximum(365))
  ),
];
